// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-icon-large[data-v-6c642c62]{font-size:4.5rem!important}", ""]);
// Exports
module.exports = exports;
